// Submits form
// If no errors or invalidations are detected, submit to pass
// to Recaptcha for actual submission.
// ----------------------------------------------------------------

import $ from 'jquery';
import { inputValidationOnClick } from './input-validation-on-click';
import { validationContinue } from './validation-continue';

const directionForwardTrigger = $('.js-formDirectionSubmitTrigger');

$(directionForwardTrigger).on('click', function() {

    var fieldset = $(this).closest('fieldset');

    inputValidationOnClick(fieldset);
    var stepValid = validationContinue(fieldset);

    if (stepValid) {
        window.onSubmitDonationForm = (() => {
            document.querySelector('#consolidated-donate-form').submit();
        });
    }

});
